// Tips — consejos prácticos por ciudad del viaje actual
import { Link } from "react-router-dom";
import { ChevronLeft, Info } from "lucide-react";
import { motion } from "framer-motion";
import { useState, useMemo } from "react";
import { useTripBase } from "../hooks/useTripBase";
import { useTrip } from "../auth/TripContext";

export default function Tips() {
  const base = useTripBase();
  const { trip } = useTrip();
  const tipsData = trip?.tips || {};
  const CITIES = useMemo(() => Object.keys(tipsData), [tipsData]);
  const [city, setCity] = useState(CITIES[0] || "");
  const data = tipsData[city];

  return (
    <div className="container-app pt-6 pb-28" data-testid="tips-page">
      <Link
        to={base || "/"}
        className="inline-flex items-center gap-1 text-sm text-[hsl(var(--muted))] mb-4"
        data-testid="tips-back"
      >
        <ChevronLeft size={16} /> Inicio
      </Link>
      <h1 className="text-3xl font-bold leading-tight">Tips prácticos</h1>
      <p className="text-sm text-[hsl(var(--muted))] mt-1 mb-5">
        Todo lo útil para no equivocarse
      </p>

      <div className="flex gap-2 mb-5 overflow-x-auto hide-scrollbar">
        {CITIES.map((c) => (          <button
            key={c}
            onClick={() => setCity(c)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
              city === c
                ? "bg-[hsl(var(--ink))] text-[hsl(var(--bg))]"
                : "bg-[hsl(var(--bg-card))] text-[hsl(var(--ink))] border border-[hsl(var(--line))]"
            }`}
            data-testid={`tips-city-${c}`}
          >
            {tipsData[c]?.flag || "🌐"} {c}
          </button>
        ))}
      </div>

      {data && (
        <>
          {/* Cabecera */}
          <motion.div
            key={city}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="card-paper p-4 mb-5 border-l-4 border-[hsl(var(--accent))]"
            data-testid="tips-currency-card"
          >
            <p className="text-[10px] uppercase tracking-wider font-semibold text-[hsl(var(--muted))] mb-1">
              Moneda
            </p>
            <p className="text-sm leading-relaxed">{data.currency}</p>
            {data.source && (
              <p className="text-[10px] text-[hsl(var(--muted))] mt-2 italic">
                {data.source}
              </p>
            )}
          </motion.div>

          {/* Secciones */}
          <div className="space-y-3">
            {data.sections.map((s, i) => (
              <motion.div
                key={`${city}-${i}`}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.04 * i }}
                className="card-paper p-4"
                data-testid={`tips-section-${i}`}
              >
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-2xl shrink-0">{s.icon}</span>
                  <h3 className="text-base font-bold leading-tight">{s.title}</h3>
                </div>
                <ul className="space-y-2">
                  {s.items.map((it, j) => (
                    <li
                      key={j}
                      className="text-sm serif text-[hsl(var(--ink-soft))] leading-[1.55] flex gap-2"
                    >
                      <span className="text-[hsl(var(--accent))] shrink-0">›</span>
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>

          <p className="text-xs text-[hsl(var(--muted))] mt-6 text-center italic flex items-center justify-center gap-1">
            <Info size={11} /> Curado desde mochileandoporelmundo.com + experiencia local
          </p>
        </>
      )}
    </div>
  );
}
